import { render } from "./VideoInfo.vue?vue&type=template&id=01649c52&scoped=true"
import script from "./VideoInfo.vue?vue&type=script&lang=js"
export * from "./VideoInfo.vue?vue&type=script&lang=js"

import "./VideoInfo.vue?vue&type=style&index=0&id=01649c52&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01649c52"]])

export default __exports__